import { Navigate, Route, Routes } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import Landing from './pages/Landing/Landing';
import Dashboard from './pages/Dashboard/Dashboard';
import Community from './pages/Community/Community';
import ResetPassword from './pages/ResetPassword/ResetPassword';
import Auth from './components/Auth/Auth';
import ProtectedRoute from './components/ProtectedRoute/ProtectedRoute';
import PricingPage from './pages/PricingPage/PricingPage';
import Terms from './pages/Terms/Terms';
import Privacy from './pages/Privacy/Privacy';
import Refund from './pages/Refund/Refund';

export default function App() {
  return (
    <AuthProvider>
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/pricings" element={<PricingPage />} />
        <Route path="/pricing" element={<PricingPage />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/refund" element={<Refund />} />
        <Route path="/refund-policy" element={<Refund />} />
        <Route path="/refunds" element={<Refund />} />
        <Route path="/community" element={<Community />} />
        <Route path="/login" element={<Auth />} />
        <Route path="/signup" element={<Auth />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          }
        />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </AuthProvider>
  );
}

